import { useQuery } from "@tanstack/react-query";
import { getMe } from "@/lib/members-api";
import { useOrgId } from "@/lib/org-context";

export function useMe() {
  const orgId = useOrgId();

  const { data, isPending } = useQuery({
    queryKey: ["me", orgId],
    queryFn: getMe,
    enabled: !!orgId,
  });

  const role = data?.role ?? null;

  return {
    me: data ?? null,
    role,
    isOwner: role === "owner",
    isAdmin: role === "admin" || role === "owner",
    isManager: role === "manager" || role === "admin" || role === "owner",
    isPending,
  };
}
